import React from 'react';
import PropTypes from 'prop-types';

import { clickAsLink } from 'helpers/link_helpers';
import { fetchPerson } from './api';
import PaginationButtons from '../../pagination_buttons';
import { getItem } from 'helpers/session_storage_helper';

const rootPath = '/contacts/people';

const allPeopleIds = getItem("contactsPeopleIds", []);

export default class PeoplePaginationButtons extends React.Component {
  static propTypes = {
    currentIndex: PropTypes.number,
    personId: PropTypes.number.isRequired
  };

  state = {
    nextIndex: null,
    prevIndex: null
  };

  componentDidMount() {
    const { currentIndex } = this.props;

    if (currentIndex != null) {
      this.prevContact(currentIndex - 1);
      this.nextContact(currentIndex + 1);
    }
  }

  handleClick = (e, index) => {
    if (index  >= 0 && index < allPeopleIds.length) {
      clickAsLink(window, `${rootPath}/${allPeopleIds[index]}?offset=${index}`, e);
    }
  }

  nextContact = (nextIndex) => {
    if (nextIndex < allPeopleIds.length  && nextIndex != null)  {
      if (allPeopleIds[nextIndex] === undefined) return;
      fetchPerson(allPeopleIds[nextIndex]).then(() => {
        this.setState({ nextIndex: nextIndex });
      }).catch(() => {
        // this.nextContact(nextIndex++);
      });
    }
  }

  prevContact = (prevIndex) => {
    if (prevIndex >= 0  && prevIndex != null) {
      if (allPeopleIds[prevIndex] === undefined) return;
      fetchPerson(allPeopleIds[prevIndex]).then(() => {
        this.setState({ prevIndex: prevIndex });
      }).catch(() => {
        // this.prevContact(prevIndex--);
      });
    }
  }

  render() {
    const { currentIndex, personId } = this.props;
    const { nextIndex, prevIndex } = this.state;

    if (currentIndex != null) {
      return (
        <PaginationButtons
          allIds={allPeopleIds}
          currentIndex={currentIndex}
          entityId={personId}
          nextIndex={nextIndex}
          prevIndex={prevIndex}
          onClick={this.handleClick}
        />
      );
    } else {
      return null;
    }
  }
}
